export default "__VITE_ASSET__004fef2b__"